module.exports = function() {
  return new Worker(__webpack_public_path__ + "0d9b9a0cb213980c3b22.worker.js");
};